// Export only the summary already returned by Laravel; never fetch additional rows.
export function chartRows(summary) {
  if (!Array.isArray(summary.rows)) return [];
  return summary.rows.map(row => {
    if (!Number.isSafeInteger(row.patient_count) || row.patient_count < 0) throw new Error('Invalid patient count');
    return { label: row.category === null ? '(NULL — not recorded)' : row.category === '' ? '(empty string)' : String(row.category), count: row.patient_count };
  });
}
function cell(value) {
  let text = value == null ? '' : String(value);
  // Spreadsheet applications may interpret formulas even inside quoted CSV fields.
  if (/^[\s\u0000-\u001f]*[=+\-@]/.test(text) || /^[\t\r\n]/.test(text)) text = "'" + text;
  return '"' + text.replace(/"/g, '""') + '"';
}
export function summaryCSV(summary) {
  if (!summary || typeof summary.answer !== 'string' || !['count','group_count','trend','region_compare'].includes(summary.applied_query?.operation)) throw new Error('Invalid summary');
  const rows = chartRows(summary), q = summary.applied_query;
  const lines = [
    ['MitraCare patient summary'], ['Answer', summary.answer], ['Scope', summary.scope],
    ['Source', 'patients'], ['Retrieved at', summary.retrieved_at], ['Request reference', summary.request_id],
    ['Operation', q.operation], ['Group by', q.group_by || 'None'],
    ['Result completeness', summary.truncated ? 'Partial: largest returned groups only; no complete total' : 'Complete returned summary'],
    ['Filter combination', 'AND'],
  ];
  if (q.filters?.length) q.filters.forEach(f => lines.push(['Filter', f.field, f.operator, f.operator === 'eq' ? f.value : 'NULL']));
  else lines.push(['Filters','None']);
  if (q.date_filter) lines.push(['Date field',q.date_filter.field],['Start date',q.date_filter.start],['End date',q.date_filter.end],['Date basis',summary.date_basis || 'Recorded event date; Asia/Kolkata']);
  if (q.regions) lines.push(['Selected regions', q.regions.join(', ')]);
  lines.push([]);
  if (q.operation === 'count') {
    if (!Number.isSafeInteger(summary.count) || summary.count < 0) throw new Error('Invalid count');
    lines.push(['Patient count'],[summary.count]);
  } else { lines.push(['Stored value','Patient count']);rows.forEach(r => lines.push([r.label,r.count])); }
  if (q.operation === 'region_compare') {
    lines.push([],['Region','Active','Inactive','Share of selected total (%)']);
    summary.rows.forEach(r => lines.push([r.category,r.active_count,r.inactive_count,r.share_percent == null ? 'Not applicable' : r.share_percent]));
    lines.push([],['Left region','Right region','Difference (left minus right)','Percent difference vs right (%)']);
    summary.comparisons.forEach(p => lines.push([p.left,p.right,p.difference,p.percent_difference_vs_right == null ? 'Undefined: right count is zero' : p.percent_difference_vs_right]));
  }
  return '\uFEFF' + lines.map(row => row.map(cell).join(',')).join('\r\n') + '\r\n';
}
export function downloadSummary(summary) {
  const csv = summaryCSV(summary), url = URL.createObjectURL(new Blob([csv], {type:'text/csv;charset=utf-8'}));
  const link=document.createElement('a');link.href=url;link.download='mitracare-patient-summary.csv';document.body.appendChild(link);
  try { link.click(); } finally { link.remove();setTimeout(() => URL.revokeObjectURL(url),1000); }
}
